// extracted by mini-css-extract-plugin
export default {"componentWrapper":"Positioned_componentWrapper__FBj+e"};